var React = require('react');

function RefreshInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.33333 1.33325C8.33333 1.33325 8.8995 1.41413 11.2426 3.75728C13.5858 6.10042 13.5858 9.89941 11.2426 12.2426C10.4125 13.0727 9.39952 13.6088 8.33333 13.8507M8.33333 1.33325L12.3333 1.33325M8.33333 1.33325L8.33333 5.33325M5.66667 14.6665C5.66667 14.6665 5.10051 14.5856 2.75736 12.2424C0.414213 9.89928 0.414213 6.10029 2.75736 3.75715C3.58754 2.92696 4.60048 2.39092 5.66667 2.14901M5.66667 14.6665L1.66667 14.6666M5.66667 14.6665L5.66667 10.6666","stroke":"#407A7D","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

RefreshInline.defaultProps = {"width":"14","height":"16","viewBox":"0 0 14 16","fill":"none"};

module.exports = RefreshInline;

RefreshInline.default = RefreshInline;
